import { Box, styled } from "@mui/material";

export const EditSystemUserWrapper = styled(Box)(({ theme }) => {
    return {
        overflow: "hidden",
        "& .title-box": {
            marginBlockEnd: "var(--basic-margin)",
        },
        "& .fieldset-wrapper": {
            padding: "var(--basic-padding) calc(var(--basic-padding)/1.5)",
            border: "1px solid #D7D7D7",
            borderRadius: "20px",
            overflow: "hidden",
            marginBlockEnd: "var(--basic-margin)"
        },
        "& fieldset": {
            display: "flex",
            flexDirection: "column",
        },
        "& .button-box": {
            overflow: "hidden",
            marginBlockStart: "var(--basic-margin)",
            "& button": {
                width: "100%",
                [theme.breakpoints.up("miniTablet")]: {
                    width: "auto",
                }
            }
        },
        "& .MuiInputBase-root": {
            border: "none",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        },
        "& .admin-avatar": {
            width: '38px',
            height: '38px',
            borderRadius: '50%',
            objectFit: 'cover'
        },
    }
})